import { motion } from 'framer-motion'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { LOCAL_KEYS } from '../../constants/storageKeys'
import { safeLocalStorage } from '../../utils/safeStorage'

const ConsentGate = ({ onNext, onBack, onOpenDatenschutz }) => {
	const { t } = useTranslation('startPage')
	const [generalConsent, setGeneralConsent] = useState(false)
	const [privacyConsent, setPrivacyConsent] = useState(false)

	return (
		<div className='section-card'>
			<motion.div
				initial={{ opacity: 0, y: 10 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.5 }}
			>
				<h2 className='section-title'>{t('consentGate.title')}</h2>

				<div
					style={{
						backgroundColor: 'rgba(245, 158, 11, 0.1)',
						borderLeft: '4px solid #f59e0b',
						borderRadius: '0 8px 8px 0',
						padding: '20px',
						marginBottom: '25px',
						color: 'var(--text-primary)',
					}}
				>
					<h3 style={{ marginTop: 0, fontSize: '1.1rem', marginBottom: '10px' }}>
						{t('consentGate.noticeTitle')}
					</h3>
					<p style={{ fontSize: '1.1rem', lineHeight: '1.6', marginBottom: '10px' }}>
						{t('consentGate.noticeText1')}
					</p>
					<p style={{ fontSize: '1.1rem', lineHeight: '1.6', margin: '0 0 10px 0' }}>
						{t('consentGate.noticeText2')}
					</p>
					<p style={{ fontSize: '1.1rem', lineHeight: '1.6', margin: 0, fontWeight: 600 }}>
						{t('consentGate.languageNotice')}
					</p>
				</div>

				<p
					style={{
						fontSize: '1.1rem',
						lineHeight: '1.6',
						color: 'var(--text-secondary)',
						marginBottom: '25px',
					}}
				>
					{t('consentGate.privacyIntro')}{' '}
					<button
						type='button'
						onClick={onOpenDatenschutz}
						style={{
							display: 'inline',
							background: 'none',
							border: 'none',
							padding: 0,
							color: 'var(--accent-hover)',
							textDecoration: 'underline',
							textAlign: 'inherit',
							cursor: 'pointer',
							font: 'inherit',
						}}
					>
						{t('consentGate.openPrivacyButton')}
					</button>
				</p>

				<div
					style={{ marginBottom: '30px', display: 'flex', flexDirection: 'column', gap: '15px' }}
				>
					<div className='u-row-start'>
						<input
							type='checkbox'
							id='general-consent'
							checked={generalConsent}
							onChange={e => setGeneralConsent(e.target.checked)}
							style={{
								marginTop: '4px',
								width: '20px',
								height: '20px',
								minWidth: '20px',
								minHeight: '20px',
								cursor: 'pointer',
								flexShrink: 0,
								accentColor: 'var(--accent-color)',
							}}
						/>
						<label
							htmlFor='general-consent'
							style={{ fontSize: '1.1rem', cursor: 'pointer', lineHeight: '1.6' }}
						>
							{t('consentGate.generalConsentLabel')}
						</label>
					</div>

					<div className='u-row-start'>
						<input
							type='checkbox'
							id='privacy-consent'
							checked={privacyConsent}
							onChange={e => setPrivacyConsent(e.target.checked)}
							style={{
								marginTop: '4px',
								width: '20px',
								height: '20px',
								minWidth: '20px',
								minHeight: '20px',
								cursor: 'pointer',
								flexShrink: 0,
								accentColor: 'var(--accent-color)',
							}}
						/>
						<label
							htmlFor='privacy-consent'
							style={{
								fontSize: '1.1rem',
								cursor: 'pointer',
								lineHeight: '1.6',
								color: 'var(--text-primary)',
							}}
						>
							{t('consentGate.privacyConsentLabel')}
						</label>
					</div>
				</div>

				<div className='navigation-footer'>
					<button className='btn-secondary-action' onClick={onBack}>
						{t('common:back')}
					</button>
					<button
						className='btn-primary-action'
						onClick={() => {
							safeLocalStorage.setItem(LOCAL_KEYS.CONSENT, 'true')
							onNext()
						}}
						disabled={!generalConsent || !privacyConsent}
						style={{
							opacity: generalConsent && privacyConsent ? 1 : 0.5,
							cursor: generalConsent && privacyConsent ? 'pointer' : 'not-allowed',
						}}
					>
						{t('consentGate.startButton')}
					</button>
				</div>
			</motion.div>
		</div>
	)
}

export default ConsentGate
